import TownBuyerLandingPage from "./TownBuyerLandingPage";
const MedfordLanding = () => (
  <TownBuyerLandingPage townName="Medford" slug="homes-for-sale-medford" savedLinkId="10357" viewAllUrl="https://homes.prpsj.com/i/homes-for-sale-medford-ac" />
);
export default MedfordLanding;
